import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

export const logoStyle = recipe({
  base: {
    display: "block",
  },
  variants: {
    size: {
      xs: { height: rem(20), width: rem(20) },
      s: { height: rem(24), width: rem(24) },
      m: { height: rem(28), width: rem(28) },
      l: { height: rem(40), width: rem(40) },
      xl: { height: rem(48), width: rem(48) },
    },
  },
  defaultVariants: {
    size: "l",
  },
});

export const imageStyle = recipe({
  base: {
    width: "100%",
    height: "100%",
  },
  variants: {
    contain: {
      true: {
        objectFit: "contain",
        objectPosition: "center",
        transform: "scale(1.2)",
      },
    },
  },
});
